var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#11B50C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0531 8.28025C18.66 7.88727 18.127 7.6665 17.5711 7.6665C17.0153 7.6665 16.4822 7.88727 16.0892 8.28025L8.67708 15.6933C8.46092 15.9093 8.31178 16.1831 8.2476 16.4819L7.67625 19.1477C7.66118 19.2178 7.6639 19.2904 7.68415 19.3591C7.70441 19.4278 7.74155 19.4903 7.7922 19.541C7.84284 19.5916 7.90536 19.6288 7.97406 19.649C8.04276 19.6693 8.11543 19.672 8.18545 19.6569L10.8515 19.0856C11.1502 19.0214 11.4241 18.8723 11.6401 18.6561L19.0531 11.2436C19.446 10.8505 19.6667 10.3176 19.6667 9.76191C19.6667 9.20622 19.446 8.67327 19.0531 8.28025ZM16.6957 8.88629C16.93 8.66466 17.2416 8.54319 17.5642 8.54771C17.8867 8.55223 18.1947 8.68238 18.4228 8.91049C18.6509 9.1386 18.781 9.44666 18.7854 9.76918C18.7898 10.0917 18.6683 10.4032 18.4466 10.6375L18.0608 11.0233L16.3095 9.27245L16.6957 8.88629ZM15.703 9.87849L17.4543 11.6297L11.0345 18.0505C10.9351 18.1498 10.8092 18.2183 10.6719 18.2477L8.65264 18.6806L9.08555 16.6619C9.11495 16.5245 9.18342 16.3986 9.28271 16.2993L15.703 9.87849Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceEdit);
export default __webpack_public_path__ + "static/media/service-edit.e0ac43d29bd229a40c3ff7bd618e3e18.svg";
export { ForwardRef as ReactComponent };